import { UberconferenceReconnectButton } from './UberconferenceReconnectButton';
export const UberconferenceReconnectionConfig = {
  reconnectButton: UberconferenceReconnectButton
};